import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getAllClient() {
    const res = await fetch(API_ENDPOINT + "client/get-all/" + getToken());
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function getClient(client, request) {
    const append = Boolean(request) || request === "" ? "?request=" + request : "";
    const res = await fetch(API_ENDPOINT + "client/details/" + getToken() + "/" + client + append);
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export function validName(name) {
    if (!name || /\d/.test(name) || /[^\w\s]/.test(name)) return false;
    if (name.length < 5) return false;
    return true;
}

export function validGSTNumber(gstNumber) {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[A-Z0-9]{1}$/;
    if (gstRegex.test(gstNumber))
        return true;
    else
        return false;
}

export function validRequiredAddress(line) {
    if (!line || /^\d+$/.test(line)) return false;
    if (line.length < 3) return false;
    if (/[^a-zA-Z0-9\-,\s]/.test(line)) return false;
    return true;
}

export function validOptionalAddress(line) {
    if (!line) return true;
    return validRequiredAddress(line)
}

export function validEmail(email) {
    if (!email || email.trim() === '') return true;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email))
        return true;
    else
        return false;
}

export function validPhoneNumber(phoneNumber, required) {
    if ((!phoneNumber || phoneNumber.trim() === '') && !required) return true;
    const phoneRegex = /^[0-9]{10}$/;
    if (phoneRegex.test(phoneNumber))
        return true;
    else
        return false;
}

export function formatIndianPhone(phone) {
    var match = String(phone).match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '+91 ' + match[1] + ' ' + match[2] + ' ' + match[3];
    return phone;
}

export async function newClient(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "client/new", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function updateBasic(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "client/update-basic", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function updateTax(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "client/update-tax", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function updateContact(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "client/update-contact", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function updateShipping(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "client/update-shipping", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}
